import classNames from "classnames";
import { FC, PropsWithChildren } from "react";
import styles from "./StatusBadge.module.css";

export type StatusBadgeColor = "success" | "info" | "warning" | "error" | "grey";

export type StatusBadgeProps = PropsWithChildren<{
  color: StatusBadgeColor;
  dot?: boolean;
}>;

const StatusBadge: FC<StatusBadgeProps> = ({ color, dot, children }) => (
  <span className={classNames(styles.badge, styles[color])}>
    {dot && <span className={styles.dot} />}
    {children}
  </span>
);

export default StatusBadge;
